import React from "react";
import { Button } from "@/components/ui/button";
import { Crown } from "lucide-react";

export function EmptyArena({ keywordName, onClaim }) {
  const name = keywordName || "this keyword";
  return (
    <div
      data-testid="empty-arena"
      className="relative overflow-hidden rounded-3xl border border-white/10 bg-black px-6 py-14 sm:py-20 text-center"
    >
      {/* ambient neon glow */}
      <div
        className="pointer-events-none absolute inset-0 opacity-70"
        style={{ background: "radial-gradient(600px 300px at 50% 15%, rgba(16,185,129,0.16), transparent 70%)" }}
      />

      {/* glowing empty podium visual (echoes the PodiumOne bars) */}
      <div className="relative flex items-end justify-center gap-3 mb-10" aria-hidden>
        <div className="w-14 h-24 rounded-md border-2 border-cyan-400/70 bg-cyan-400/5" style={{ boxShadow: "0 0 24px rgba(34,211,238,0.45), inset 0 0 12px rgba(34,211,238,0.25)" }} />
        <div className="relative w-16 h-36 rounded-md border-2 border-emerald-400/80 bg-emerald-400/5" style={{ boxShadow: "0 0 30px rgba(16,185,129,0.55), inset 0 0 14px rgba(16,185,129,0.3)" }}>
          <Crown className="absolute -top-9 left-1/2 -translate-x-1/2 w-8 h-8 text-emerald-300 animate-pulse" style={{ filter: "drop-shadow(0 0 10px rgba(16,185,129,0.8))" }} />
        </div>
        <div className="w-14 h-20 rounded-md border-2 border-green-400/70 bg-green-400/5" style={{ boxShadow: "0 0 24px rgba(74,222,128,0.45), inset 0 0 12px rgba(74,222,128,0.25)" }} />
      </div>

      <div className="relative max-w-xl mx-auto">
        <h2 data-testid="empty-arena-headline" className="font-display font-black text-3xl sm:text-4xl tracking-tighter text-white">
          This Arena is Empty.
        </h2>
        <p data-testid="empty-arena-subtext" className="mt-4 text-base text-white/60 leading-relaxed">
          No one has claimed <span className="text-white font-semibold">#{name}</span> yet. You can lock in the permanent #1 spot right now for just <span className="text-white font-semibold">$5 / RM 5</span>. Use your signup bonus to claim the throne for free before a competitor does.
        </p>
        <Button
          data-testid="empty-arena-claim-btn"
          onClick={onClaim}
          className="mt-8 rounded-full h-12 px-8 bg-gradient-to-r from-emerald-500 to-teal-500 hover:opacity-90 active:scale-95 transition-all font-bold text-black"
        >
          <Crown className="w-4 h-4 mr-2" /> Claim #1 Spot Now
        </Button>
      </div>
    </div>
  );
}
